import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import LoginPage from './components/LoginPage';
import ServiceMapperPage from './pages/ServiceMapperPage';
// SSO/OIDC disable logic removed. AppRouter always uses MSAL authentication for app access.
function AppRouter() {
  return (
    <>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <ServiceMapperPage />
      </AuthenticatedTemplate>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <NotificationProvider>
          <AppRouter />
          <Toaster position="top-center" />
        </NotificationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
